<template>
  <div class="font-sans antialiased text-gray-900 leading-normal tracking-wider content feedback-content">
    <div class="min-h-screen flex flex-col font-sans">
      <div class="flex-grow">
        <div class="max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0">

          <!--Main Col-->

          <div class="w-full lg:w-4/5 rounded-lg lg:rounded-lg shadow-2xl bg-white mx-6 lg:mx-0 my-16">

            <div class="p-4 md:p-12 text-center">
              <div class="flex justify-center">
                <a class="no-underline hover:no-underline" href="https://www.greengeeks.com/">
                  <img alt="GreenGeeks logo" src="/static/img/amui/logo_black.png" class="mb-6">
                </a>
              </div>
              <br/>
              <div v-if="loading" class="mt-2 mb-6">
                <preloader />
              </div>
              <p v-else-if="loadError" class="mt-2 mb-6 text-red-500">{{ loadError }}</p>
              <div v-else-if="complete">
                <h3 class="text-lg font-bold pt-8 lg:pt-0">
                  <svg class="h-6 w-6 fill-current inline-block ggs-green pb-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                    <path d="m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm12.7,15.1l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.6-0.1-0.7-0.3l-7.8-8.4-.2-.2c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.3 0.4,0.9 0,1.3z"/>
                  </svg>
                  Thank you! Your feedback has been received.
                </h3>
                <p class="text-lg">You may now close this page.</p>
              </div>
              <template v-else>
                <div class="flex justify-center">
                  <h4 class="pb-4 font-bold">
                    Thank you for your feedback. What is the most important reason for your score?
                  </h4>
                </div>
                <textarea v-model="feedback"
                          data-vv-as="Feedback"
                          data-vv-name="feedback"
                          v-validate="'required'"
                          rows="5"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <p class="text-red-500 text-xs text-left">
                  {{ errors.collect('feedback')[0] }}
                </p>
                <div class="pt-6">
                  <button @click="submit"
                          :disabled="submitting"
                          class="inline-flex bg-green-600 hover:bg-teal-900 text-white font-bold py-2 leading-normal px-4 rounded">
                    <svg v-show="submitting"
                         class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                         xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Submit Survey
                  </button>
                  <p class="mt-2 text-red-500">{{ submitError }}</p>
                </div>
              </template>
            </div>

          </div>
          <div>
            <!--Footer-->
            <footer class="bg-white">
              <div class="container max-w-4xl mx-auto my-28 lg:my-0 mx-auto">
                <div class="flex md:flex-row flex-col justify-around pt-6 text-center md:text-left">
                  <div>
                    <p>Copyright © 2008 - {{ (new Date()).getFullYear() }} GreenGeeks.com - All Rights Reserved.</p>
                    <p>
                    <p class="copyright-links">
                      <a href="https://www.greengeeks.com/legal/tos"
                         class="no-underline hover:underline text-gray-800 hover:text-green-600">Terms of Service</a> /
                      <a href="https://www.greengeeks.com/legal/privacy"
                         class="no-underline hover:underline text-gray-800 hover:text-green-600">Privacy Policy</a>
                    </p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import amapi from '@/api/amapi'
import Preloader from '@/components/Common/Preloader'
import { hideChat } from '@/helpers/helpers'

export default {
  name: 'Feedback',
  components: {
    Preloader,
  },
  data () {
    return {
      loading: false,
      submitting: false,
      max: 10,
      min: 0,
      link_hash: '',
      score: null,
      feedback: '',
      loadError: '',
      submitError: '',
      complete: false
    }
  },
  methods: {
    async loadNps () {
      this.loading = true
      try {
        const {
          resultmsg,
          result,
          link_hash
        } = await amapi.makecall('nps_load', {
          link_hash: this.$route.params.link_hash,
          score: this.score
        })
        if (result == 'error') {
          throw new Error(resultmsg)
        }
        this.link_hash = link_hash
      } catch (e) {
        console.log(e)
        this.loadError = e
      } finally {
        this.loading = false
      }
    },
    initScore () {
      const routeScore = Number.parseInt(this.$route.params.score)
      if (!routeScore && routeScore !== 0) {
        this.$router.push({ name: 'dashboard' })
        return
      }
      // after chat load - hide it
      const LC_API = window.LC_API || {}
      LC_API.on_after_load = function () {
        hideChat()
      }
      this.score = routeScore >= this.min && routeScore <= this.max
        ? routeScore
        : routeScore > this.max ? this.max : null
    },
    applyCustomValidatorDictionary () {
      const dict = {
        custom: {
          score: {
            required: 'Please, specify Your Score.'
          }
        }
      }
      this.$validator.localize('en', dict)
    },
    async submit () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.submitting = true
      const params = {
        link_hash: this.link_hash,
        score: this.score,
        feedback: this.feedback
      }
      try {
        const { result, resultmsg } = await amapi.makecall('nps_submit', params)
        if (result == 'error') {
          this.submitError = resultmsg
        } else {
          this.complete = true
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.submitting = false
      }
    }
  },
  mounted () {
    this.initScore()
    this.loadNps()
    this.applyCustomValidatorDictionary()
  }
}
</script>

<style lang="scss">
  /*
  * Generate a custom page style
  * 1. Run: purgecss --config purgecss.config.js
  * 2. Copy the content of ./custom-pages.css to scss file
  */
  @import "../../assets/scss/custom-pages";

  .focus\:shadow-outline:focus{
    box-shadow:0 0 0 3px rgba(56, 161, 105, 0.3)
  }
  .feedback-content {
    overflow-y: auto !important;
  }
  .content:before {
    background-image: none;
  }
</style>
